var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import TextCard from './text/text';
import { CARD_TYPES } from '../../data-parser/const';
import DivCard from '../div-card/card';

/**
 * Фабрика карточек ответа помощника
 * @param  {Object} card
 * @param  {Object} props
 * @return {Object}
 */
export default (function (card, props) {
    switch (card.type) {
        case CARD_TYPES.div:
            return React.createElement(DivCard, _extends({
                key: card.id
            }, card, {
                messageId: props.id,
                onAction: props.onAction,
                onContentUpdated: props.onContentUpdated
            }));
        case CARD_TYPES.text:
        case CARD_TYPES.textWithButton:
            return React.createElement(TextCard, _extends({
                key: card.id
            }, card, {
                onAction: props.onAction,
                backgroundColor: props.backgroundColor,
                textColor: props.textColor,
                borderColor: props.borderColor,
                actionsTextColor: props.actionsTextColor
            }));
        default:
            return null;
    }
});